// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/8cf39363c007dd2f1b35.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9f987252afb4236bcb9f","125":"e517c44adb2454069cfc","126":"0d7954196acf2923a30f"}[chunkId] + ".chunk.js";
};